import { gql } from '@apollo/client';

export const getListingSettings = gql`
    {
      getListingSettings {
        id
        typeName
        fieldType
        typeLabel
        step
        isEnable
        listSettings {
          id
          typeId
          itemName
          itemNameFR
          itemDescription
          otherItemName
          maximum
          minimum
          startValue
          endValue
          isEnable
          image
          icon
        }
      }
    }
    `;

export const getListingSpecSettings = gql`
    query ($id:Int!) {
      getListingSpecSettings (id:$id) {
        id
        typeName
        fieldType
        typeLabel
        step
        isEnable
        listSettings {
          id
          typeId
          itemName
          otherItemName
          maximum
          minimum
          startValue
          endValue
          isEnable
          image
        }
        status
      }
    }
    `;

export const userListing = gql`
    query ($listId:Int!, $preview: Boolean) {
      UserListing (listId:$listId, preview: $preview) {
        id
        userId
        country
        street
        buildingName
        city
        state
        zipcode
        lat
        lng
        isMapTouched
        bedrooms
        residenceType
        beds
        personCapacity
        bathrooms
        user {
          id
          email
          userBanStatus
          profile{
            firstName
            lastName
            dateOfBirth
          }
        }
        userAmenities {
          amenitiesId
          listsettings{
            itemName
            settingsType {
              typeName
            }
          }
        }
        userSafetyAmenities {
          safetyAmenitiesId
          listsettings{
            itemName
            settingsType {
              typeName
            }
          }
        }
        userSpaces {
          spacesId
          listsettings{
            itemName
            settingsType {
              typeName
            }
          }
        }
        settingsData {
          id
          settingsId
          listsettings {
            id
            itemName
            settingsType {
              typeName
            }
          }
        }
        userBedsTypes{
          id
          listId
          bedCount
          bedType
        }
        listingRooms{
          id
          listId
          roomNumber
          roomType
          bedTypes{
            id
            bedCount
            bedType
          }
        }
      }
    }
    `;

export const userListingStepTwo = gql`
    query ($listId:Int!, $preview: Boolean) {
      UserListing (listId:$listId, preview: $preview) {
        id
        userId
        title
        description
        coverPhoto
      }
    }
    `;

export  const createListing = `query (
    $roomType:String,
    $houseType:String,
    $residenceType:String,
    $bedrooms:String,
    $buildingSize:String,
    $bedType:String,
    $beds:Int,
    $personCapacity:Int,
    $bathrooms:Float,
    $bathroomType:String,
    $country:String,
    $street:String,
    $buildingName:String,
    $city:String,
    $state:String,
    $zipcode:String,
    $lat:Float,
    $lng:Float,
    $bedTypes: String,
    $rooms: String,
  ) {
      createListing (
        roomType:$roomType,
        houseType:$houseType,
        residenceType: $residenceType,
        bedrooms: $bedrooms,
        buildingSize: $buildingSize
        bedType: $bedType
        beds: $beds
        personCapacity: $personCapacity
        bathrooms: $bathrooms
        bathroomType: $bathroomType
        country: $country
        street: $street
        buildingName: $buildingName
        city: $city
        state: $state
        zipcode: $zipcode,
        lat: $lat,
        lng: $lng,
        bedTypes: $bedTypes,
        rooms: $rooms,
      ) {
        status
        id
      }
    }`;

export const manageListingSteps = gql`
    query ($listId: Int!, $currentStep: Int!) {
      ManageListingSteps (listId:$listId, currentStep: $currentStep) {
        id
        listId
        step1
        step2
        step3
        step4
        listing {
          id
          isReady
          isPublished
          listApprovalStatus
        }
        status
      }
    }
    `;

export const checkListing = gql`
    query($id: Int!, $type: String) {
        checkListing(id: $id, type: $type) {
            status
        }
    }
    `;

export const getStepTwo = gql`
    query getStepTwo($listId:String!) {
        getStepTwo (listId:$listId) {
          id
          userId
          title
          description
          coverPhoto
          listPhotos {
            id
            name
          }
        }  
      }
    `;

export const ListingQuery = gql` 
    query UserListing($listId:Int!,$preview: Boolean) {
      UserListing(listId:$listId, preview: $preview) {
        id
        userId
        title
        coverPhoto
        country
        city
        state
        personCapacity
        zipcode
        user {
          id
          email
          profile{
            profileId
            displayName
            firstName
            preferredLanguage
          }
        }
      }
    }`;

export const getUpcomingBookingQuery = gql`
    query getUpcomingBookings ($listId: Int!){
        getUpcomingBookings(listId: $listId){
          count
        }
      }`;

export const ListingStepsQuery = gql`
    query ($listId:String!) {
        showListingSteps (listId:$listId) {
            id
            listId
            step1
            step2
            step3
            step4
            listing {
                id
                isReady
                isPublished
                listApprovalStatus
            }
        }
    }`;

export const ManageListingQuery = gql` 
    query ManageListings{
        ManageListings {
          results{
            id
            title
            city
            updatedAt
            coverPhoto
            isPublished
            listApprovalStatus
            isReady
            listPhotos{  
                id
                name
                source
            }
            settingsData {
                listsettings {
                    id
                    itemName
                }
            }
            listingSteps {
                id
                step1
                step2
                step3
                step4
            }
        }
      }
    }`;

export const ManagePublish = gql`
    mutation ManagePublish($listId: Int!, $action: String!) {
        managePublish(listId: $listId, action: $action) {
            status
        }
    }
    `;

export const wishListStatus = gql`
    mutation updateListStatus($listId:Int!, $action: String!) {
         updateListStatus (listId:$listId, action: $action) {
            status
         }
     }
    `;

export const submitForVerificationMutation = gql`
    mutation submitForVerification($id: Int,$listApprovalStatus: String){
      submitForVerification(id:$id, listApprovalStatus: $listApprovalStatus){
          id
          status
        }
      }
    `;

export const createHistory = gql`
    mutation createListingHistory($listId:Int!, $userId: String, $status: String, $reason: String) {
      createListingHistory (listId:$listId, userId: $userId, status:$status, reason:$reason) {
            status
         }
     }
    `;

export const approveListingMutation = gql`
    mutation approveListing($id: Int, $listApprovalStatus: String){
      approveListing(id:$id, listApprovalStatus:$listApprovalStatus){
        id
        status
      }
    }
      `;

export const userListingStep3 = gql`
    query ($listId:Int!, $preview: Boolean) {
      UserListing (listId:$listId, preview: $preview) {
        id
        userId
        bookingType
        isPublished
        listApprovalStatus
        additionalRules
        houseRules {
          houseRulesId
        }
        listingData {
          bookingNoticeTime,
          checkInStart,
          checkInEnd,
          maxDaysNotice,
          minNight,
          maxNight,
          basePrice,
          weekendPrice,
          minStayWeekend,
          cleaningPrice,
          tax,
          currency,
          weeklyDiscount,
          monthlyDiscount,
          cancellationPolicy,
          taxRate,
          extraGuestThreshold,
          extraGuestFee,
          cautionDeposit,
          customDiscounts
        }
        blockedDates {
          blockedDates
          reservationId
          calendarStatus
          isSpecialPrice
          dayStatus
        }
        calendars {
          id
          name
          url
          listId
          status
        }
        listBlockedPrice {
            listId
            calendarStatus
            isSpecialPrice
            blockedDates
            calendarId
            reservationId
            dayStatus
        }
      }
    }
    `;

export const listingDataUpdate = gql`
    mutation ListingDataUpdate(
        $id: Int,
        $houseRules: [Int],
        $checkInStart:String,
        $checkInEnd:String,
        $minNight:Int,
        $maxNight:Int,
        $cancellationPolicy: Int,
        $maxDaysNotice: String,
        $bookingNoticeTime: String,
        $basePrice: Float,
        $cleaningPrice: Float,
        $currency: String,
        $tax : Float,
        $weeklyDiscount:Float,
        $monthlyDiscount:Float,
    
    ){
        ListingDataUpdate(
            id: $id,
            houseRules: $houseRules,
            checkInStart:$checkInStart,
            checkInEnd:$checkInEnd,
            minNight:$minNight,
            maxNight:$maxNight,
            cancellationPolicy: $cancellationPolicy,
            maxDaysNotice: $maxDaysNotice,
            bookingNoticeTime: $bookingNoticeTime,
            basePrice: $basePrice,
            cleaningPrice: $cleaningPrice,
            currency: $currency
            tax : $tax,
            weeklyDiscount: $weeklyDiscount,
            monthlyDiscount: $monthlyDiscount,
        ) {
         status
      }
    }
    `;

export const getListquery = `
    query GetListMeta($listId: Int!) {
      getListMeta(listId: $listId) {
        id
        title
        description
        isPublished
        listApprovalStatus
        coverPhoto
        listPhotos {
          id
          name
        }
        status
        lat
        lng
        listingData {
          maxNight
          minNight
        }
      
      }
    }
    `;